<template>
  <div class="m-manage-filters-wrapper">
    <b-modal v-model="listModal" centered hide-footer title="Управление фильтрами">
      <div class="m-manage-filters">
        <div class="m-manage-filters-list-actions">
          <!-- <c-button
            label="Сохранить текущие параметры"
            size="small"
            :responsive="true"
            @click="saveClick"
            :icon="{icon:'check', color: 'success'}"
            class="m-manage-filters-list-action"
          />-->

          <c-button
            v-if="costructor"
            label="Конструктор фильтров"
            size="small"
            :responsive="true"
            :icon="{ icon: 'constructor' }"
            class="m-manage-filters-list-action m-manage-filters-list-action-constructor"
            @click="openConstructorModal"
          />
        </div>

        <div class="m-manage-filters-list-notice" :class="{ 'm-manage-filters-list-notice_hidden': !emptyError }">
          <div class="m-manage-filters-list-notice-icon">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="7" cy="7" r="6.5" fill="white" stroke="#FF238D" />
              <circle cx="7" cy="10" r="1" fill="#FF238D" />
              <rect x="6" y="3" width="2" height="5" rx="1" fill="#FF238D" />
            </svg>
          </div>

          <div class="m-manage-filtes-list-notice-text">
            Для сохранения текущих фильтров нужно выбрать хотя бы один параметр
          </div>
        </div>

        <c-list
          class="m-manage-filters-content-list"
          :items="setsUserFilters"
          @clickAction="clickFilterAction"
          @clickTitle="applyFilter"
        />
      </div>
    </b-modal>

    <b-modal v-model="saveModal" centered hide-footer title="Управление фильтрами">
      <div class="m-manage-filters">
        <c-input-old v-model="newFilter" placeholder="Введите название для параметров фильтра" />

        <div class="m-manage-filters-actions">
          <c-button class="m-manage-filters-action" label="Отменить" @click="openModal('list')" />

          <c-button
            class="m-manage-filters-action"
            label="Сохранить"
            color="primary"
            :disabled="newFilter === ''"
            @click="saveFilter"
          />
        </div>
      </div>
    </b-modal>

    <b-modal v-model="shareModal" centered hide-footer title="Управление фильтрами">
      <div class="m-manage-filters">
        <div class="m-manage-filters-content">
          Выберите сотрудников, с которыми хотите поделиться фильтром
          <strong>{{ selectedItem && selectedItem.title }}</strong>
        </div>

        <div class="m-manage-filters__share">
          <c-input-old
            v-model="selectedUsers"
            placeholder="Сотрудники"
            type="select"
            :multiple="true"
            :items="users"
            :searchable="true"
            class="m-manage-filters__share-select"
          />

          <div class="m-manage-filters__share-switchers">
            <c-switcher
              v-for="user in users"
              :key="user.value"
              class="m-manage-filters__share-switcher"
              :label="user.label"
              :image="user.avatar"
              type="checkbox"
            />
          </div>
        </div>

        <div class="m-manage-filters-actions">
          <c-button class="m-manage-filters-action" label="Отменить" @click="content = 'list'" />
          <c-button class="m-manage-filters-action" label="Поделиться" color="primary" @click="shareItem" />
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import List from "@/components/list";

import Button from "@/components/controls2/Button";
import InputOld from "@/components/controls2/Input";

import Switcher from "@/components/controls/switcher";

export default {
  name: "m-manage-filters",

  components: {
    "c-button": Button,
    "c-list": List,
    "c-input-old": InputOld,
    "c-switcher": Switcher,
  },

  props: ["active", "query", "costructor", "enabledFields", "module", "fieldValues"],

  data() {
    return {
      newFilter: "",
      selectedItem: null,
      selectedUsers: null,
      localActive: this.active,

      localEnabledFields: this.enabledFields,

      localQuery: this.query,

      localFieldValues: this.fieldValues,

      listModal: false,
      saveModal: false,
      shareModal: false,
      emptyError: false,
      setsUserFilters: [],
    };
  },

  computed: {
    ...mapGetters("commonTest", ["getUsers", "getFilters", "getCurrentUserId", "getFilterById"]),

    ...mapGetters("test", ["getEmployeesFilters", "getEmployeesFilterById"]),

    // computedFilters() {
    // return this.getEmployeesFilters.map(function (filter) {
    //   let user = this.getUsers.find(function (user) {
    //     return user.id === filter.authorId;
    //   })
    //
    //   let actions = [{ icon: 'share', label: 'Поделиться', action: 'share' }];
    //
    //   let description = user ? user.name : ''
    //
    //   if (this.getCurrentUserId === filter.authorId) {
    //     description += ' (вы)';
    //     actions.unshift({ icon: 'trash', color: 'secondary', label: 'Удалить', action: 'delete' });
    //   }
    //
    //   return {
    //     id: filter.id,
    //     title: filter.name,
    //     description,
    //     actions
    //   }
    // }.bind(this));
    // },

    users() {
      return this.getUsers.map((user) => ({
        value: user.id,
        label: user.name,
        avatar: user.avatar,
      }));
    },
  },

  watch: {
    active(value) {
      this.openModal(value);
    },

    enabledFields(value) {
      this.localEnabledFields = value;
    },

    query(value) {
      this.localQuery = value;
    },

    fieldValues(value) {
      this.localFieldValues = value;
    },

    listModal(value) {
      if (!value && !this.shareModal && !this.saveModal) this.$emit("close");
    },

    shareModal(value) {
      if (!value && !this.listModal && !this.saveModal) this.$emit("close");
    },

    saveModal(value) {
      if (!value && !this.shareModal && !this.listModal) this.$emit("close");
    },

    getUserFilters(value) {
      const actions = [{ icon: "share", label: "Поделиться", action: "share" }];

      this.setsUserFilters = [
        { id: 0, title: "filters", filters: value.filters, description: "тестовый набор фильтров", actions },
      ];
    },
  },

  methods: {
    saveClick() {
      this.emptyError = false;

      if (this.localEnabledFields.length > 0) {
        this.openModal("save");
      } else {
        this.emptyError = true;
      }
    },

    openModal(value) {
      this.emptyError = false;
      if (value === "list") {
        this.listModal = true;
        this.saveModal = false;
        this.shareModal = false;
      } else if (value === "save") {
        this.saveModal = true;
        this.listModal = false;
        this.shareModal = false;
      } else if (value === "share") {
        this.shareModal = true;
        this.listModal = false;
        this.saveModal = false;
      }
    },

    closeModals() {
      this.shareModal = false;
      this.listModal = false;
      this.saveModal = false;
    },

    clickFilterAction(data) {
      this.openModal(data.action);
      this.selectedItem = data;
    },

    applyFilter(data) {
      if (this.module === "employees") {
        this.$emit("setFilters", data.filters);
      }

      this.closeModals();
    },

    deleteItem() {
      if (this.module === "employees") {
        // this.$store.commit()
      } else {
        this.$store.commit("calculations/deleteFilter", this.selectedItem.id);
        this.openModal("list");
      }
    },

    saveFilter() {
      if (this.newFilter !== "") {
        if (this.module === "employees") {
          // let setUserFilters = this.localEnabledFields.map((item) => item.name)
          // this.$store.dispatch('employees/saveUserFilters', setUserFilters).then((i) =>{
          //   this.$store.dispatch('employees/getUserFilters')
          // })
        } else {
          this.$store.commit("calculations/saveFilter", {
            id: 4,
            name: this.newFilter,
            authorId: 2,
            value: this.query,
          });
        }

        this.openModal("list");
      }
    },

    shareItem() {
      this.$store.commit("calculations/shareFilter", {
        filterId: this.selectedItem.id,
        users: this.selectedUsers,
      });

      this.openModal("list");
    },

    openConstructorModal() {
      this.listModal = false;
      this.$emit("openConstructorModal");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.m-manage-filters {
  position: relative;
  width: 100%;
  transition: 0.2s;
  // margin-top: 20px;

  &-content {
    font-size: 15px;
    margin-bottom: 30px;
    line-height: 18px;

    &-list {
      margin-top: 22px;
    }
  }

  &-list-actions {
    // margin-bottom: 22px;
    display: flex;
  }

  &-list-action {
    margin-right: 10px;

    &-constructor {
      @media screen and (max-width: 1024px) {
        display: none;
      }
    }
  }

  &-list-notice {
    font-size: 13px;
    color: $color-secondary;
    display: flex;
    margin-top: 10px;
    transition: 0.2s;

    &-icon {
      margin-right: 10px;
    }

    &_hidden {
      margin-top: -38px;
      visibility: hidden;
      opacity: 0;
    }
  }

  &__share {
    &-switchers {
      display: none;
    }
  }

  &-actions {
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;

    @media screen and (max-width: 700px) {
      margin: 20px -20px -20px;
    }
  }

  &-action {
    margin-left: 10px;

    &:first-child {
      margin-left: 0;
    }

    @media screen and (max-width: 700px) {
      margin-left: 0;
      width: 50%;
      border-radius: 0;
      height: 38px;
    }
  }

  @media screen and (max-width: 700px) {
    &__share {
      &-switchers {
        display: block;
      }

      &-select {
        display: none;
      }
    }
  }
}
</style>
